var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconPlus(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.7735 16.6949C10.5925 16.5139 10.4803 16.2641 10.4812 15.9878C10.4812 15.4353 10.9281 14.9885 11.4806 14.9885H20.5165C21.069 14.9885 21.5159 15.4353 21.5159 15.9878C21.5159 16.5403 21.069 16.9872 20.5165 16.9872H11.4806C11.2044 16.9882 10.9545 16.876 10.7735 16.6949Z",
    fill: "#333333"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.2905 21.2175C15.1095 21.0364 14.9973 20.7866 14.9982 20.5104L14.9992 11.466C14.9992 10.9135 15.446 10.4666 15.9985 10.4666C16.552 10.4676 16.9989 10.9144 16.9979 11.466L16.997 20.5104C16.997 21.0628 16.5501 21.5097 15.9976 21.5097C15.7213 21.5107 15.4706 21.3975 15.2905 21.2175Z",
    fill: "#333333"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconPlus);
export default __webpack_public_path__ + "static/media/iconPlus.46659d420508f6c290788f187aff4afb.svg";
export { ForwardRef as ReactComponent };